export default "__VITE_ASSET__BxqxRp6g__"